import { Icon, RichRow, Text } from '@taxdown/piccolo-web';
import { RowProps } from './types';

const Row = ({ label, icon, isRouteCompleted, hasError, progress }: RowProps): JSX.Element => (
  <RichRow
    startIcon={<Icon color="default" icon={icon} height={24} width={24} />}
    startText={
      <Text type="paragraphs" color="dark" size="S_L_S">
        {label}
      </Text>
    }
    progress={progress !== 100 ? progress : undefined}
    endIcons={
      isRouteCompleted()
        ? [<Icon color="default" icon="IconTickSolidSGreen" height={16} width={16} />]
        : hasError
          ? [<Icon color="default" icon="IconWarningAttentionSolidS" height={16} width={16} />]
          : []
    }
  />
);

export default Row;
